/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Simplified)
export default {
  'ai-mate.agent-message.error': '重新加载聊天',
  'ai-mate.agent-message.error.aup-link-text': '可接受的使用政策',
  'ai-mate.agent-message.error.aup-one': '无法回应该提示。',
  'ai-mate.agent-message.error.aup-two': '您的提示可能不符合我们的{link}。请尝试使用其他提示。',
  'ai-mate.agent-message.error.copy-trace-id': '复制跟踪 ID',
  'ai-mate.agent-message.error.network-error': '似乎出现网络问题。',
  'ai-mate.agent-message.error.resend': '重新发送消息',
  'ai-mate.agent-message.error.trace-id': '跟踪 ID：{traceId}',
  'ai-mate.agent-picker.dropdown-item.agents-dropdown-group-title': '可提供帮助的支持人员',
  'ai-mate.agent-picker.dropdown-item.chat-history': '聊天记录',
  'ai-mate.agent-picker.dropdown-item.create': '创建支持人员',
  'ai-mate.agent-picker.dropdown-item.debug-mode': '调试模式',
  'ai-mate.agent-picker.dropdown-item.get-help': '获取帮助',
  'ai-mate.agent-picker.dropdown-item.list': '浏览支持人员',
  'ai-mate.agent-picker.dropdown-item.submit-feedback': '提交反馈',
  'ai-mate.agent-picker.dropdown-trigger-label': '选择支持人员',
  'ai-mate.agent-selector.default-agent-name': '聊天',
  'ai-mate.browse-agents-view.close-button': '关闭支持人员视图',
  'ai-mate.browse-agents-view.header-title': '浏览支持人员',
  'ai-mate.chat-history.conversationLimit':
    '是否在寻找之前的聊天记录？我们会清除 30 天之前的聊天记录，以保持 Atlassian Intelligence 的顺畅运行。',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-1': '我最近为哪些 Confluence 页面内容做出过贡献？',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-2': '查找分配给我的所有 Jira 工作单。',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-3': '我们的差旅政策是怎样的？',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-4': '为营销活动起草 Confluence 页面。',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-5': '如何创建项目时间线？',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-6': '给潜在客户写一封跟进电子邮件。',
  'ai-mate.chat-history.empty-state.brand-name': '聊天',
  'ai-mate.chat-history.empty-state.browse-agents-button-label': '浏览支持人员',
  'ai-mate.chat-history.empty-state.browse-agents-button-text': '浏览支持人员',
  'ai-mate.chat-history.empty-state.chat-with-agent-header': '与 Rovo 支持人员聊天',
  'ai-mate.chat-history.empty-state.confluence-home-llm-label-1': '关于此空间',
  'ai-mate.chat-history.empty-state.confluence-home-llm-label-2': '关于此空间的洞察信息',
  'ai-mate.chat-history.empty-state.confluence-home-llm-label-3': '空间建议',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-1': '我编写的页面上是否有新的动态？',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-10': '`人员`是否评论过我发布的任何页面？',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-11': '`页面`的关键要点有哪些？',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-2': '是否有提及我的新评论？',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-3': '为此空间中最近发布的页面生成摘要。',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-4': '为我上周对页面的贡献生成摘要。',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-5': '您能否将此`页面`用更简单易懂的方式写出来？',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-6': '创建用于项目管理的游戏计划模板。',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-7': '我们对常见客户问题开展了哪些调研？',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-8': '本周，我的团队中是否有人发布过任何新页面？',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-9': '本周，`人员`是否发布过任何新页面？',
  'ai-mate.chat-history.empty-state.confluence-home.suggestion1': '我编写的页面上是否有新的动态？',
  'ai-mate.chat-history.empty-state.confluence-home.suggestion2': '是否有提及我的新评论？',
  'ai-mate.chat-history.empty-state.confluence-home.suggestion3': '为此空间中最近发布的页面生成摘要',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-1': '您能改进此页面上的文字吗？',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-2': '为此页面撰写执行摘要。',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-3': '给我一些其他相关页面的链接。',
  'ai-mate.chat-history.empty-state.confluence-page-edit.suggestion1': '您能改进此页面上的文字吗？',
  'ai-mate.chat-history.empty-state.confluence-page-edit.suggestion2': '为此页面撰写执行摘要。',
  'ai-mate.chat-history.empty-state.confluence-page-edit.suggestion3': '给我一些其他相关页面的链接。',
  'ai-mate.chat-history.empty-state.confluence-page-llm-label-1': '关于本页面',
  'ai-mate.chat-history.empty-state.confluence-page-llm-label-2': '有关此页面内容的更多信息',
  'ai-mate.chat-history.empty-state.confluence-page-llm-label-3': '页面建议',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-1': '为我正在查看的内容生成摘要。',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-2': '对此页面上的评论生成摘要。',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-3': '请像讲给初学者一样给我解释一下此页面。',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-4': '此页面内容由谁撰写，撰写者属于哪个团队？',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-5': '此页面上的内容在过去一周是否有变化？',
  'ai-mate.chat-history.empty-state.confluence-page-view.suggestion1': '对我正在查看的内容生成摘要。',
  'ai-mate.chat-history.empty-state.confluence-page-view.suggestion2': '此页面上的内容在过去一周是否有变化？',
  'ai-mate.chat-history.empty-state.confluence-page-view.suggestion3': '对此页面上的评论生成摘要。',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-1': '关于此白板',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-2': '此白板上的更多内容',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-3': '此白板上的洞察信息',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-prompt-1': '对我正在查看的内容生成摘要。',
  'ai-mate.chat-history.empty-state.confluence-whiteboard.prompt-2': '突出显示此处呈现的所有模式或趋势。',
  'ai-mate.chat-history.empty-state.confluence-whiteboard.prompt-3': '找出此白板中记录的所有关键操作项或决定。',
  'ai-mate.chat-history.empty-state.confluence-whiteboard.suggestion1': '对我正在查看的内容生成摘要。',
  'ai-mate.chat-history.empty-state.confluence-whiteboard.suggestion2': '突出显示此处呈现的所有模式或趋势。',
  'ai-mate.chat-history.empty-state.confluence-whiteboard.suggestion3': '找出此白板中记录的所有关键操作项或决定。',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.be-productive': '提高工作效率',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.draft-content': '撰写内容草稿',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.find-information': '查找信息',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.find-people': '查找人员',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.get-answers': '获得答案',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.measure-productivity': '衡量工作效率',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.rephrase-content': '改写内容',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.stay-up-to-date': '了解最新信息',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.summarize-content': '生成内容摘要',
  'ai-mate.chat-history.empty-state.created-by-label': '<text>创建者：</text>{creatorName}',
  'ai-mate.chat-history.empty-state.intro-text-headline': '{userName}，您好！',
  'ai-mate.chat-history.empty-state.intro-text-link-text': '探索 Rovo 聊天和支持人员',
  'ai-mate.chat-history.empty-state.intro-text-subheadline': '选取对话开场白或提出任意问题。',
  'ai-mate.chat-history.empty-state.jira-home-prompt-1': '查找本周更新的 Jira 事务。',
  'ai-mate.chat-history.empty-state.jira-home-prompt-1-issue-term-refresh': '查找本周更新的 Jira 工作项。',
  'ai-mate.chat-history.empty-state.jira-home-prompt-2': '哪些 Jira 事务优先级最高？',
  'ai-mate.chat-history.empty-state.jira-home-prompt-2-issue-term-refresh': '哪些 Jira 工作项优先级最高？',
  'ai-mate.chat-history.empty-state.jira-home-prompt-3': '哪些 Jira 事务的评论提及了我？',
  'ai-mate.chat-history.empty-state.jira-home-prompt-3-issue-term-refresh': '哪些 Jira 工作项的评论提及了我？',
  'ai-mate.chat-history.empty-state.jira-home-prompt-4': '为 `Jira 事务`的评论生成摘要。',
  'ai-mate.chat-history.empty-state.jira-home-prompt-4-issue-term-refresh': '为 `Jira 工作项` 的评论生成摘要。',
  'ai-mate.chat-history.empty-state.jira-home-prompt-5': '为用户故事创建描述模板。',
  'ai-mate.chat-history.empty-state.jira-home.suggestion1': '查找本周更新的 Jira 事务。',
  'ai-mate.chat-history.empty-state.jira-home.suggestion1-issue-term-refresh': '查找本周更新的 Jira 工作项。',
  'ai-mate.chat-history.empty-state.jira-home.suggestion2': '哪些事务具有最高优先级？',
  'ai-mate.chat-history.empty-state.jira-home.suggestion2-issue-term-refresh': '哪些工作项具有最高优先级？',
  'ai-mate.chat-history.empty-state.jira-home.suggestion3': '哪些事务的评论提及了我？',
  'ai-mate.chat-history.empty-state.jira-home.suggestion3-issue-term-refresh': '哪些工作项的评论提及了我？',
  'ai-mate.chat-history.empty-state.jira-issue-list.suggestion1': '哪些事务未分配？',
  'ai-mate.chat-history.empty-state.jira-issue-list.suggestion1-issue-term-refresh': '哪些工作项未分配？',
  'ai-mate.chat-history.empty-state.jira-issue-list.suggestion2': '哪些事务处于待处理状态的时间最长？',
  'ai-mate.chat-history.empty-state.jira-issue-list.suggestion2-issue-term-refresh':
    '哪些工作项处于待处理状态的时间最长？',
  'ai-mate.chat-history.empty-state.jira-issue-list.suggestion3': '谁的任务最多？',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-1': '关于此事务',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-1-issue-term-refresh': '关于此工作项',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-2': '有关此事务内容的更多信息',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-2-issue-term-refresh': '有关此工作项内容的更多信息',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-3': '关于此事务的洞察信息',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-3-issue-term-refresh': '关于此工作项的洞察信息',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-4': '事务建议',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-4-issue-term-refresh': '工作项建议',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-1': '是否有与此类似的 Jira 事务？',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-1-issue-term-refresh': '是否有与此类似的 Jira 工作项？',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-2': '我怎样才能改进描述？',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-3': '我可以为此事务添加哪些标签？',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-3-issue-term-refresh': '我可以为此工作项添加哪些标签？',
  'ai-mate.chat-history.empty-state.jira-issue-view.suggestion1': '是否有与此类似的 Jira 事务？',
  'ai-mate.chat-history.empty-state.jira-issue-view.suggestion1-issue-term-refresh': '是否有与此类似的 Jira 工作项？',
  'ai-mate.chat-history.empty-state.jira-issue-view.suggestion2': '我怎样才能改进描述？',
  'ai-mate.chat-history.empty-state.jira-issue-view.suggestion3': '我可以为此事务添加哪些标签？',
  'ai-mate.chat-history.empty-state.jira-issue-view.suggestion3-issue-term-refresh': '我可以为此工作项添加哪些标签？',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-1': '关于此项目',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-2': '关于此项目的洞察信息',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-3': '有关此项目内容的更多信息',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-4': '项目建议',
  'ai-mate.chat-history.empty-state.jira-project-prompt-1': '哪些工作已有一段时间无人接手？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-10': '查找类似的 Jira 事务并将其分组。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-10-issue-term-refresh': '查找类似的 Jira 工作项并将其分组。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-11': '是否有任何与父事务无关的 Jira 事务？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-11-issue-term-refresh':
    '是否有与父工作项未关联的 Jira 工作项？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-12': '获取 `Jira 事务`描述，并将其与最佳实践保持一致。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-12-issue-term-refresh':
    '获取 `Jira 工作项`描述，并将其与最佳实践保持一致。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-13': '为 `Jira 事务`的评论生成摘要。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-13-issue-term-refresh': '为 `Jira 工作项` 的评论生成摘要。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-14': '为用户故事创建描述模板。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-14-issue-term-refresh': '为用户故事创建描述模板。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-2': '是否有任何 Jira 事务被阻止？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-2-issue-term-refresh': '是否有 Jira 工作项被阻止？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-3':
    '列出当前处于“进行中”状态的 Jira 事务，并按经办人对其进行分组。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-3-issue-term-refresh':
    '列出当前处于“进行中”状态的 Jira 工作项，并按经办人对其进行分组。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-4': '有多少事务已分配给`人员`？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-4-issue-term-refresh': '有多少工作项已分配给 `人员`？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-5': '`人员`是否就此冲刺中的任何 Jira 事务发表过评论？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-5-issue-term-refresh':
    '`人员` 是否就此冲刺中的任何 Jira 工作项发表过评论？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-6': '哪些 Jira 事务未分配？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-6-issue-term-refresh': '哪些 Jira 工作项未分配？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-7': '哪些 Jira 事务处于待处理状态的时间最长？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-7-issue-term-refresh':
    '哪些 Jira 工作项处于待处理状态的时间最长？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-8': '谁的任务最多？',
  'ai-mate.chat-history.empty-state.message': '获取解答、产生新想法和加快日常工作。',
  'ai-mate.chat-history.empty-state.suggestion1': '我的工作单是否有已经过期的？',
  'ai-mate.chat-history.empty-state.suggestion2': '接下来我应该做什么？',
  'ai-mate.chat-history.empty-state.suggestion3': '撰写我这一周的最新情况',
  'ai-mate.chat-history.empty-state.unknown-llm-label-1': '建议',
  'ai-mate.chat-history.store-assistant.message-actions.cancel-button': '取消',
  'ai-mate.chat-history.store-assistant.message-actions.confirm-button': '确认',
  'ai-mate.chat-history.store-assistant.message-actions.errored-button': '完成此操作时出现问题',
  'ai-mate.chat-input.actions-button.label': '插入元素',
  'ai-mate.chat-input.add-a-link-button.label': '添加链接',
  'ai-mate.chat-input.deleted-agent-icon-label': '已删除的支持人员',
  'ai-mate.chat-input.deleted-agent-start-new-chat': '开启新聊天',
  'ai-mate.chat-input.deleted-agent-warning': '此支持人员已删除。',
  'ai-mate.chat-input.drag-and-drop-message': '通过拖放来添加上下文以获得更好的结果',
  'ai-mate.chat-input.file-close-icon-label': '移除文件',
  'ai-mate.chat-input.mention-someone-button.label': '提及某人或某一团队',
  'ai-mate.chat-input.placeholder': '首先撰写一条提示',
  'ai-mate.chat-input.send-button.label': '提交',
  'ai-mate.chat-input.stop-generating-button.label': '停止生成',
  'ai-mate.chat-input.store-user-messages.label': '记录此消息以帮助我们提高回答质量',
  'ai-mate.chat-main-header.back-button.label': '返回',
  'ai-mate.chat-main-header.copy-agent-link-button.label': '复制链接',
  'ai-mate.chat-main-header.default-agent-name': '聊天',
  'ai-mate.chat-main-header.edit-agent-button.label': '编辑',
  'ai-mate.chat-main-header.link-copied-to-profile': '已复制 URL',
  'ai-mate.chat-view.chat-item.chat-delete-label': '删除',
  'ai-mate.chat-view.chat-item.chat-rename-label': '重命名',
  'ai-mate.chat-view.chat-item.options-button-label': '聊天选项',
  'ai-mate.content-renderer.profile-card.view-profile-button': '查看个人资料',
  'ai-mate.content-renderer.view-code-button-label': '查看分析结果',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.cancel-button-label.non-final': '取消',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.conversation-not-found-failure-message.non-final':
    '您尝试删除的对话不存在。',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-button-label.non-final': '删除',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-conversation-title.non-final':
    '删除对话 "{name}"？',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.generic-failure-message.non-final':
    '删除对话时出错。请重试。',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.modal-body.non-final':
    '确定要删除此对话吗？此操作无法撤消。',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.cancel-button-label.non-final': '取消',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.channel-not-found-error-message.non-final':
    '您尝试编辑的通道不存在。',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.edit-name-label.non-final': '名称',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.generic-error-message.non-final':
    '编辑对话时出错。请重试。',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.modal-title.non-final': '编辑对话',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.name-is-same-error-message.non-final':
    '该名称与当前名称相同。',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.save-button-label.non-final': '保存',
  'ai-mate.conversation-list-view.back-button.label': '返回',
  'ai-mate.conversation-list-view.close-chat-button.label': '关闭聊天',
  'ai-mate.conversation-list-view.header-title': '聊天记录',
  'ai-mate.conversation-list-view.new-chat-button.label': '新建聊天',
  'ai-mate.conversation-list-view.no-chat': '无结果',
  'ai-mate.conversation-list-view.search-input.placeholder': '搜索聊天',
  'ai-mate.expander.hide-details': '隐藏详细信息',
  'ai-mate.expander.show-details': '显示更多详细信息',
  'ai-mate.footer.beta': '测试版',
  'ai-mate.footer.info': '内容质量可能有所不同',
  'ai-mate.footer.info-truncated': '内容质量可能有所不同',
  'ai-mate.footer.info-updated': '内容取决于您的权限，且其质量可能会各不相同',
  'ai-mate.footer.rovo-branding-label': '{logo} Rovo',
  'ai-mate.footer.rovo-branding-label-updated': 'Rovo {logo}',
  'ai-mate.main-chat.close-chat-button-label': '关闭',
  'ai-mate.main-chat.maximize-chat-button-label': '全屏',
  'ai-mate.main-chat.minimize-chat-button-label': '还原视图',
  'ai-mate.main-chat.new-chat-button-label': '全新',
  'ai-mate.main-chat.new-chat-button-label-full-screen': '新聊天',
  'ai-mate.main-panel.failed-to-load-agents': '获取支持人员失败',
  'ai-mate.message-renderer.error': '如果问题仍然存在，请告诉我们。',
  'ai-mate.message-renderer.error-title': '加载内容失败',
  'ai-mate.pubsub-listener.forge-auth-faiure-message': '确认失败，请稍后重试。',
  'ai-mate.pubsub-listener.forge-auth-success-message': '确认成功，请重新发送提示。',
  'ai-mate.sidebar.agents-icon.text': '支持人员',
  'ai-mate.sidebar.agents-icon.tooltip': '浏览 Rovo 支持人员',
  'ai-mate.sidebar.chat-icon.text': '聊天',
  'ai-mate.sidebar.chat-icon.tooltip': '与 Rovo 聊天',
  'ai-mate.sidebar.debug-mode-icon.tooltip': '调试',
  'ai-mate.sidebar.get-help-icon.tooltip': '获取帮助',
  'ai-mate.sidebar.give-feedback-icon.tooltip': '提供反馈',
  'ai-mate.sidebar.history-icon.text': '历史记录',
  'ai-mate.sidebar.history-icon.tooltip': '查看您的聊天记录',
  'chat-history.rate-limit-warning': '{secondsRemaining, plural, other {请等待 {secondsRemaining,number} 秒}}',
  'chat-history.rate-limit-warning-description': '消息发送速度过快，请稍候。',
  'chatHistory.storeAssistant.badResponseLabel': '不佳回复',
  'chatHistory.storeAssistant.copyResponseLabel': '复制',
  'chatHistory.storeAssistant.goodResponseLabel': '良好回复',
  'rovo-chat.chat-input.editor-context-banner.editor-context-toggle-label': '使用此上下文',
  'rovo-chat.data-sculptor-modal.cancel': '取消',
  'rovo-chat.data-sculptor-modal.title': '分析',
  'rovo-chat.file-upload-button.label': '上传文件',
  'rovo-chat.file-upload-button.max-files-label': '{maxFiles, plural, other {已达到 {maxFiles,number} 个文件的限制}}',
  'rovo-chat.file-upload-dropzone.drag-drop-message': '通过拖放来添加上下文',
  'rovo-chat.message-file.icon-label': '文件',
  'rovo-chat.store-assistant.insert-replace.confluence-insert-button-label': '插入到页面',
  'rovo-chat.store-assistant.insert-replace.generic-insert-button-label': '插入',
  'rovo-chat.store-assistant.insert-replace.jira-insert-button-label': '插入到事务',
  'rovo-chat.store-assistant.insert-replace.replace-button-label': '替换所选文本',
  'rovo-chat.store-assistant.insert-replace.tooltip-message':
    '您当前的上下文不支持此功能。尝试在页面上选择、编写或编辑文本。',
};
